import { Navigate, useOutlet, useParams } from "react-router-dom";
import { DirectSubroutesOf } from "../../routing";
import { useShallowCalendarStore } from "../../store";
import { buildCalendarPath } from "./build-calendar-path";

export interface CalendarDateRedirectPageProps<T extends DirectSubroutesOf<"/calendar/view/:viewId">> {
  viewType?: T;
  date?: Date | "today";
  replace?: boolean;
}

export const CalendarDateRedirectPage = <T extends DirectSubroutesOf<"/calendar/view/:viewId">>({
  viewType,
  date,
  replace = true,
}: CalendarDateRedirectPageProps<T>) => {
  const outlet = useOutlet();
  const params = useParams();
  const { lastSelectedViewType, lastSelectedViewId } = useShallowCalendarStore(
    "lastSelectedViewType",
    "lastSelectedViewId"
  );

  if (outlet) return outlet;

  const to = buildCalendarPath({
    viewType,
    fallbackViewType: lastSelectedViewType,
    fallbackViewId: lastSelectedViewId,
    date: date ?? "today",
    params,
  });

  return <Navigate to={to} replace={replace} />;
};
